import ApiClient from "@/api/ApiClient.ts";
import qs from "qs";
import {
  NOTIFICATION_GIVE_BACK_TYPE,
  NOTIFICATION_TYPE_ALARM,
  NOTIFICATION_TYPE_NO_CLIENT,
  NOTIFICATION_TYPE_VOICE,
} from "@/utils/constants";
import { CLEARED_NOTIFICATION, NEW_NOTIFICATION } from "@/events/constants";

const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
const HIDE_NOTIFICATION = "HIDE_NOTIFICATION";

const state = {
  notifications: [],
  appNotifications: [],
};

const mutations = {
  [SET_NOTIFICATIONS](state, notifications) {
    const currentNotifications = state.notifications;
    const newNotifications = notifications.filter(
      (notification) => !currentNotifications.find((n) => n.inserted === notification.inserted)
    );
    const clearedNotifications = currentNotifications.filter(
      (notification) => !notifications.find((n) => n.inserted === notification.inserted)
    );
    newNotifications.forEach((n) => window.$bus.emit(NEW_NOTIFICATION, n));
    clearedNotifications.forEach((n) => window.$bus.emit(CLEARED_NOTIFICATION, n));
    state.notifications = notifications;
  },
  [HIDE_NOTIFICATION](state, id) {
    state.shownNotifications = [...state.shownNotifications.filter((n) => n.id !== id)];
  },
};

const actions = {
  async setNotifications({ commit }, notifications) {
    commit(SET_NOTIFICATIONS, notifications);
  },

  async answerNotification(_, payload) {
    const params = {
      ...payload.params,
    };
    const answer = typeof payload.data === "string" ? payload.data : JSON.stringify(payload.data);
    const urlFormData = qs.stringify({ answer });
    try {
      const api = ApiClient();
      await api.put("notifications/answer", urlFormData, {
        params,
        headers: { "content-type": "application/x-www-form-urlencoded" },
      });
    } catch (error) {
      console.error("ERROR on answerNotification: ", error.message);
      throw error;
    }
  },
};

const getters = {
  notifications(state) {
    return state.notifications;
  },
  alarmNotifications(state) {
    return state.notifications
      ? state.notifications.filter((notify) => notify.type === NOTIFICATION_TYPE_ALARM)
      : [];
  },
  voiceNotifications(state) {
    return state.notifications
      ? state.notifications.filter((notify) => notify.type === NOTIFICATION_TYPE_VOICE)
      : [];
  },
  noClientNotifications(state) {
    return state.notifications
      ? state.notifications.filter((notify) => notify.type === NOTIFICATION_TYPE_NO_CLIENT)
      : [];
  },
  giveBackNotifications(state) {
    return state.notifications
      ? state.notifications.filter((notify) => notify.type === NOTIFICATION_GIVE_BACK_TYPE)
      : [];
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
